module.exports = __webpack_public_path__ + "static/safari-59d0012c4f0cca73312bf85c4c37a2d7.png";